import AdvertisementBanner from './AdvertisementBanner'

export default AdvertisementBanner
